import React, {FC} from "react"

import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Body, H2} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"

import {Img, Step} from "./styled"

interface Props extends InjectIntl {}

const HRISSetup: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()

  return (
    <>
      <H2 color={theme.colors.brand.default} textAlign="center" marginBottom={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.setup.title" />
      </H2>
      <Flex justifyContent="center" marginBottom={3}>
        <Step width="35%" justifyContent="flex-end" paddingLeft={4}>
          <Card padding={[4, 3]} marginRight={3}>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.setup.step1.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black} marginBottom={2}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.setup.step1.desc" />
            </Body>
          </Card>
        </Step>
        <Step width="35%" justifyContent="flex-start" paddingRight={4}>
          <Card padding={[4, 3]}>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.setup.step2.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black} marginBottom={2}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.setup.step2.desc" />
            </Body>
          </Card>
        </Step>
      </Flex>
      <Flex justifyContent="center" marginBottom={3}>
        <Step width="35%" justifyContent="flex-end" paddingLeft={4}>
          <Card padding={[4, 3]} marginRight={3}>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.setup.step4.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black} marginBottom={2}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.setup.step4.desc" />
            </Body>
          </Card>
        </Step>
        <Step width="35%" justifyContent="flex-start" paddingRight={4}>
          <Card padding={[4, 3]}>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.setup.step3.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black} marginBottom={2}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.setup.step3.desc" />
            </Body>
          </Card>
        </Step>
      </Flex>
    </>
  )
}

export default injectIntl(HRISSetup)
